import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles/index';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import TextField from '@material-ui/core/TextField';
import DashboardSelect from "./DashboardSelect";
import {getSegmentSelectLists} from "../../api";
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

const styles = theme => ({
    root: {
        width: '100%',
        overflowX: 'auto',
        marginTop: 0,
        marginBottom: 16,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    textField: {
        marginTop: 0,
        width: '100%',
    },
    tooltipWrapper: {
        marginTop: 32,
        textAlign: 'center',
    },
    loadingSpinner: {
        color: theme.palette.primary[500]
    },
    loaderWrapper: {
        padding: '0 0 0 16px'
    }
});

class DashboardSegmentCreator extends PureComponent {
    state = {
        isLoading: false,
        name: '',
        options: null,
        values: {
            utm_source: '',
            utm_medium: '',
            utm_campaign: '',
            utm_content: '',
            utm_term: '',
            conversion_test_variant_id: '',
            device_type: '',
            first_answer_app_type: '',
            process_url: '',
        },
        filterBasedOnField: null,
        segmentNameChangedManually: false,
    };

    onValueChange = (alias, value, refresh = true) => {
        let values = this.state.values
        values[alias] = value

        let filterBasedOnField = !this.state.filterBasedOnField ? alias : this.state.filterBasedOnField
        if (values[filterBasedOnField] === '') {
            filterBasedOnField = null
        }

        let newState = {
            values: values,
            filterBasedOnField: filterBasedOnField
        }

        if (!this.state.segmentNameChangedManually) { //TODO: This can be much better
            newState.name = value
        }

        this.setState(newState, () => {
            if (refresh) {
                this.refresh()
            } else {
                this.forceUpdate()
            }
        })
    };

    handleChange = name => event => {
        this.setState({[name]: event.target.value, segmentNameChangedManually: true});
    };

    componentDidMount() {
        this.refresh()
    }

    refresh = () => {
        const {from, to} = this.props;
        const {values, filterBasedOnField} = this.state;

        const updateState = response => {
            const data = response.data

            const newState = {
                isLoading: false,
                options: data.options,
            };

            this.setState(newState)
        }

        this.setState({isLoading: true, segmentBehaviourData: null}, () => {
            getSegmentSelectLists(from, to, values, filterBasedOnField).then(updateState).catch((err) => {
                alert(err)
            })
        });
    }

    create = () => {
        const {name, values} = this.state

        this.props.create(name, values)
    }


    render() {
        const {classes, toggle} = this.props;
        const {isLoading, options, values, name, filterBasedOnField} = this.state;
        return (
            <Card className={classes.root}>
                <CardContent>
                    <Grid container spacing={0}>
                        <Grid item xs={12} sm={6} md={6}>
                            <TextField
                                id="standard-name"
                                label="Segmentin nimi"
                                className={classes.textField}
                                value={name}
                                onChange={this.handleChange('name')}
                                margin="normal"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} align={'end'}>
                        </Grid>
                    </Grid>
                    {options && <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={3}>
                            <DashboardSelect label={'UTM Source'} alias={'utm_source'} options={options.utmSource}
                                             value={values.utm_source} onChange={this.onValueChange}
                                             isBaseField={filterBasedOnField === 'utm_source'}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <DashboardSelect label={'UTM Medium'} alias={'utm_medium'} options={options.utmMedium}
                                             value={values.utm_medium} onChange={this.onValueChange}
                                             isBaseField={filterBasedOnField === 'utm_medium'}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <DashboardSelect label={'UTM Campaign'} alias={'utm_campaign'} options={options.utmCampaign}
                                             value={values.utm_campaign} onChange={this.onValueChange}
                                             isBaseField={filterBasedOnField === 'utm_campaign'}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <DashboardSelect label={'UTM Content'} alias={'utm_content'} options={options.utmContent}
                                             value={values.utm_content} onChange={this.onValueChange}
                                             isBaseField={filterBasedOnField === 'utm_content'}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <DashboardSelect label={'UTM Term'} alias={'utm_term'} options={options.utmTerm}
                                             value={values.utm_term} onChange={this.onValueChange}
                                             isBaseField={filterBasedOnField === 'utm_term'}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <DashboardSelect label={'Device Type'} alias={'device_type'} options={options.deviceType}
                                             value={values.device_type} onChange={this.onValueChange}
                                             isBaseField={filterBasedOnField === 'device_type'}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <DashboardSelect label={'Conversion Test Variant'} alias={'conversion_test_variant_id'}
                                             value={values.conversion_test_variant_id}
                                             options={options.conversionTestVariantId} onChange={this.onValueChange}
                                             isBaseField={filterBasedOnField === 'conversion_test_variant_id'}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <DashboardSelect label={'First Answer App Type'} alias={'first_answer_app_type'}
                                             value={values.first_answer_app_type}
                                             options={options.firstAnswerAppType} onChange={this.onValueChange}
                                             isBaseField={filterBasedOnField === 'first_answer_app_type'}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <DashboardSelect label={'Process Url'} alias={'process_url'}
                                             value={values.process_url}
                                             options={options.processUrl} onChange={this.onValueChange}
                                             isBaseField={filterBasedOnField === 'process_url'}/>
                        </Grid>
                    </Grid>
                    }
                </CardContent>
                <CardActions className={classes.actions}>
                    {isLoading &&
                    <div className={classes.loaderWrapper}>
                        <FontAwesomeIcon size="xs" icon={['fal', 'spinner-third']} spin
                                         className={classes.loadingSpinner}/>
                    </div>
                    }
                    <Button size="small" style={{marginLeft: 'auto', color: 'grey'}} onClick={toggle}>Peruuta</Button>
                    <Button size="small" color={'primary'} onClick={this.create}>Tallenna</Button>
                </CardActions>
            </Card>
        );
    }
}

DashboardSegmentCreator.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DashboardSegmentCreator);
